import { defineStore } from "pinia";
import { IArchiveFilter } from "@/features/archive/archive.types";
import { Ref, ref } from "vue";
import { archiveService } from "@/features/archive/archive.service";
import { useNotification } from "@/utils/notification";
import { ITableHeader } from "@/types/table";

const { pushNotification } = useNotification();

export const useArchiveStore = defineStore("archive", () => {
  const taskHeaders: ITableHeader[] = [
    {
      name: "id",
      label: "No",
      width: "3%",
    },
    {
      name: "company",
      label: "Company",
      width: "14%",
    },
    {
      name: "drivers",
      label: "Drivers",
      width: "14%",
    },
    {
      name: "team",
      label: "Team",
      width: "5%",
    },
    {
      name: "users",
      label: "User",
      width: "13%",
    },
    {
      name: "date",
      label: "Start time",
      width: "6%",
    },
    {
      name: "completed_time",
      label: "End time",
      width: "6%",
    },
    {
      name: "points_awarded",
      label: "KPI",
      width: "3%",
    },
    {
      name: "status",
      label: "Status",
      width: "9%",
    },
    {
      name: "problems",
      label: "Problems",
      width: "19%",
    },
    {
      name: "actions",
      label: "",
      width: "8%",
    },
  ];
  const commonFilter = ref<IArchiveFilter>({
    page: 1,
    per_page: 50,
    status: "",
    assignee_id: "",
    shift_template_id: null,
    team_id: "",
    work_type_id: "",
    search: "",
  });

  const clearFilter = () => {
    commonFilter.value = {
      page: 1,
      per_page: 50,
      status: "",
      assignee_id: "",
      shift_template_id: null,
      team_id: "",
      work_type_id: "",
      search: "",
    };
  };

  async function getArchives(loading: Ref<boolean>, cl: any) {
    loading.value = true;
    await archiveService
      .getArchive({ ...commonFilter.value })
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function archiveTask(
    loading: Ref<boolean>,
    task_id: string,
    reason: string,
    cl: any
  ) {
    loading.value = true;
    await archiveService
      .archiveTask(task_id, { reason })
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function unarchiveTask(
    loading: Ref<boolean>,
    task_id: string,
    reason: string,
    cl: any
  ) {
    loading.value = true;
    await archiveService
      .unarchiveTask(task_id, { reason })
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function deleteTask(loading: Ref<boolean>, task_id: string, cl: any) {
    loading.value = true;
    await archiveService
      .deleteTask(task_id)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    taskHeaders,
    commonFilter,
    clearFilter,
    getArchives,
    archiveTask,
    unarchiveTask,
    deleteTask,
  };
});
